<div class="mx-auto max-w-lg py-12 px-4">
  <div class="mb-6 flex justify-center">
    <img src="assets/brand/Momentum red M.png" alt="Momentum Health" class="h-12" />
  </div>

  @if (previewLoading()) {
    <mat-card class="flex items-center justify-center gap-3 rounded-3xl border border-slate-200 bg-white p-8 shadow-xl shadow-slate-200/60">
      <mat-spinner diameter="20" />
      <span class="text-sm text-slate-500">Loading...</span>
    </mat-card>
  } @else if (previewError()) {
    <mat-card class="rounded-3xl border border-slate-200 bg-white p-8 shadow-xl shadow-slate-200/60">
      <h1 class="mb-1 text-2xl font-bold text-slate-900">Link not valid</h1>
      <p class="text-sm text-slate-500">{{ previewError() }}</p>
    </mat-card>
  } @else if (dependant(); as dep) {
    <mat-card
      class="rounded-3xl border p-8 shadow-xl shadow-slate-200/60"
      [class.border-green-200]="confirmed()"
      [class.border-slate-200]="!confirmed()"
    >
      <div class="mb-4 flex items-center gap-3">
        @if (confirmed()) {
          <mat-icon class="text-green-600" style="font-size: 2rem; width: 2rem; height: 2rem;">check_circle</mat-icon>
          <h1 class="text-xl font-semibold text-slate-900">Information confirmed</h1>
        } @else {
          <h1 class="text-xl font-semibold text-slate-900">Confirm your information</h1>
        }
      </div>
      <p class="mb-6 text-sm text-slate-500">
        @if (confirmed()) {
          The following dependant details have been confirmed.
        } @else {
          Please review the dependant details below and confirm they are correct.
        }
      </p>

      <dl class="divide-y divide-slate-100">
        <div class="flex justify-between py-3">
          <dt class="text-sm font-medium text-slate-500">Full name</dt>
          <dd class="text-sm font-semibold text-slate-900">{{ dep.firstName }} {{ dep.surname }}</dd>
        </div>
        @if (dep.dateOfBirth) {
          <div class="flex justify-between py-3">
            <dt class="text-sm font-medium text-slate-500">Date of birth</dt>
            <dd class="text-sm text-slate-900">{{ dep.dateOfBirth }}</dd>
          </div>
        }
        @if (dep.contactNumber) {
          <div class="flex justify-between py-3">
            <dt class="text-sm font-medium text-slate-500">Contact number</dt>
            <dd class="text-sm text-slate-900">{{ dep.contactNumber }}</dd>
          </div>
        }
        @if (dep.emailAddress) {
          <div class="flex justify-between py-3">
            <dt class="text-sm font-medium text-slate-500">Email address</dt>
            <dd class="text-sm text-slate-900">{{ dep.emailAddress }}</dd>
          </div>
        }
      </dl>

      @if (!confirmed()) {
        <div class="mt-6">
          @if (confirmError()) {
            <p class="mb-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{{ confirmError() }}</p>
          }

          <button
            mat-flat-button
            type="button"
            [disabled]="confirming()"
            (click)="confirm()"
          >
            @if (confirming()) {
              <mat-spinner diameter="18" />
              Confirming…
            } @else {
              Confirm information
            }
          </button>
        </div>
      }
    </mat-card>
  }
</div>
